/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/iframe-has-title */
import { ArrowBack } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import checkCircleIcon from 'assets/images/gif_Icons/checkCircleIcon.gif';
import axios from "axios";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ShowSwalWithButtons from "components/SwalAlert/swalPopupWithButtons";
import { useMaterialUIController } from "context";
import { format } from "date-fns";
import PageTitle from "examples/PageTitle/PageTitle";
import QuotationLayout from "layouts/authentication/components/QuotationLayout/QuotationLayout";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import Swal from 'sweetalert2';
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import { validateField } from "utils/generic";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';


const pdfStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%x",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};


function CustomerViewInvoice() {
  const navigate = useNavigate();
  const { id: InvoiceID } = useParams();
  const { invoiceNumber: InvoiceNumber } = useParams();
  const [loading, setLoading] = useState(false);
  const [confirmationMesssage, setConfirmationMessage] = useState('');
  const [controller] = useMaterialUIController();
  const { darkMode, } = controller;
  const [invoiceDocuments, setInvoiceDocuments] = useState([]);
  const [getDocumentFileURL, setSetDocumentFileURL] = useState('');
  const [viewDocumentInModal, setViewDocumentInModal] = useState(false);
  const [showInvoiceSection, setShowInvoiceSection] = useState(false);
  const [showClosingSection, setShowClosingSection] = useState(false);
  const [showConfirmationSection, setShowConfirmationSection] = useState(false);
  const [paymentModeErr, setPaymentModeErr] = useState(false);
  const [paymentAmountErr, setPaymentAmountErr] = useState(false);
  const [paymentTransactionIDErr, setPaymentTransactionIDErr] = useState(false);
  const customStyles = {

    table: {

      style: {
        borderColor: "lightgray",
      },
    },
    headRow: {
      style: {
        minHeight: '30px'
      },
    },
    headCells: {
      style: {
        fontSize: "12px",
      },
    },
    cells: {
      style: {

      },
    },
  };



  const [itemRowValues, setItemRowValues] = useState([
    {
      itemName: "", itemPrice: "", itemQuantity: "", gst: "", discountType: "None", discountValue: "", discountAmount: ""
    },
  ]);
  const [values, setValues] = useState({
    invoiceNumber: 'Auto Generated',
    purchaseOrderNumber: '',
    invoiceDate: new Date(),
    dueDate: new Date(),
    invoiceStatus: 'Unpaid',
    gstType: "Inclusive",
    totalAmount: 0,
    totalDiscountAmount: 0,
    totalGSTAmount: 0,
    finalAmount: 0,
    payablePendingAmount: 0,
    paymentInstruction: '',
    invoiceType: "Direct",
    currencyValue: 'USD',
    contactName: '',
    scheduleRetention: false,
  });
  const [retentionItemValues, setRetentionItemValues] = useState([]);
  const [retentionRowsCount, setRetentionRowsCount] = useState(0);
  const [paymentValues, setPaymentValues] = useState({
    paymentType: "Full Payment",
    paymentAmount: 0.00,
    paymentDate: new Date(new Date() - (new Date().getTimezoneOffset() * 60000)),
    paymentTransactionID: "",
    paymentMode: "",
  })
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [status, setStatus] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      await FetchUnpaidInvoiceForCustomer();
    };
    fetchData();
  }, []);

  const FetchUnpaidInvoiceForCustomer = async () => {
    setLoading(true);
    await axios.post(appConstants.baseURL + 'invoice/fetchUnpaidInvoiceForCustomer', { invoiceID: InvoiceID }).then(res => {

      if (res.data.Result_Output.length > 0) {
        let data = res.data.Result_Output[0];

        if (InvoiceNumber !== data.invoiceNumber) {
          navigate(`/invoice/${data.invoiceNumber}/${data._id}`);
        }
        if (data.invoiceStatus === "Paid") {

          setConfirmationMessage(`You have Paid the ${data.invoiceNumber} Invoice Amount`);
          setShowConfirmationSection(true);
          setShowInvoiceSection(false);
          setShowClosingSection(false);
        }
        else {
          setValues(data);
          data.itemsList?.length > 0 && setItemRowValues(data.itemsList);
          data.documentsList?.length > 0 && setInvoiceDocuments(data.documentsList);
          data.invoicePayment?.length > 0 && setPaymentHistory(data.invoicePayment)
          if (data.retention?.length > 0) {
            setRetentionItemValues(data.retention);
            setRetentionRowsCount(data.retention.filter(row => row.retentionStatus === "Unpaid").length);
          }
          setShowInvoiceSection(true);
        }
      } else {
        console.log("Invoice not found",);
      }
      setLoading(false);
    }).catch(error => {
      console.error("Error in fetchUnpaidInvoiceForCustomer: ", error);
    })
  }
  let columns = [
    {
      name: <p style={{ textAlign: "start", paddingLeft: "5px" }}>Item</p>,
      selector: row => row.itemName,
    },
    {
      name: `Item Price (${values.currencyValue})`,
      selector: row => row.itemPrice,
    },
    {
      name: "Item Quantitiy",
      selector: row => row.itemQuantity,
    },
    {
      name: "GST%",
      selector: row => row.gst,
    },
    // {
    //   name: "Discount Type",
    //   selector: row => row.discountType,
    // },
    // {
    //   name: "Discount Value",
    //   selector: row => row.discountValue,
    // },
    // {
    //   name: `Discount Amount (${values.currencyValue})`,
    //   selector: row => row.discountAmount,
    // },
  ];
  const documentColumns = [
    {
      name: "Document Name",
      selector: (row) => row.documentName,

    },
    {
      name: <p style={{ textAlign: "center" }}>Action</p>,
      selector: (row) => row,
      center: "true",
      cell: (row) => (
        <>
          <Grid mt={-3.2}>
            <TimelineItem
              color="info"
              icon="visibility"
              onClick={() => { handleViewDocument(row) }}
              title="View"
            />
          </Grid>


        </>
      ),
    },
  ];
  let columnRetention = [
    {
      name: "Retention No.",
      selector: row => row.retentionNumber,
      center: "true",
      style: { paddingLeft: "10px", minWidth: '120px', fontSize: "0.75rem" },

    },
    {
      name: `Due Date`,
      selector: row => row.retentionDueDate,
      center: "true",
      style: { paddingLeft: "10px", minWidth: '120px', fontSize: "0.75rem" },
    },
    {
      name: `Payment Status`,
      selector: row => row.retentionStatus,
      cell: row => (
        <p style={{ color: `${row.retentionStatus === "Paid" ? "green" : "red"}` }}>
          {row.retentionStatus}
        </p>
      ),
      center: "true",
      style: { paddingLeft: "10px", fontSize: "0.75rem", },
    },
    {
      name: `Amount (${values.currencyValue})`,
      selector: row => parseFloat(row.retentionPaymentAmount).toFixed(2),
      center: "true",
      style: { paddingLeft: "10px", fontSize: "0.75rem" },
    },
  ];
  const handleViewDocument = (selectedDocRow) => {
    setSetDocumentFileURL(appConstants.baseURL + 'quotation/viewUploadedQuotationDocument?fileName=/' + selectedDocRow.documentFileName);
    setViewDocumentInModal(true);
  };
  const handleRowSelected = (state) => {
    values.paymentType = "Retention Payment";
    let selectedAmount = 0;

    state.selectedRows.forEach(row => {
      if (row.retentionStatus === "Unpaid") {
        selectedAmount += parseFloat(row.retentionPaymentAmount);
      }
    });

    let UnpaidRetention = state.selectedRows.filter(row => row.retentionStatus === "Unpaid");
    if (UnpaidRetention.length > 0) {
      if (UnpaidRetention.length === retentionRowsCount) {
        values.paymentType = "Full Payment";
      }
    }
    setPaymentValues({ ...paymentValues, retentionInvoiceList: UnpaidRetention, paymentType: values.paymentType, paymentAmount: (selectedAmount).toFixed(2) });
  }
  const rowDisabledCriteria = row => row.retentionStatus === "Paid";

  const handleChange = (name) => (event) => {
    let inputValue = event.target.value;
    if (name === 'paymentAmount') {
      let inputValue = event.target.value;
      if (inputValue === '.') {
        inputValue = '0.';
      }

      const regex = /^\d{1,7}(?:\.\d{0,2})?$/;
      if (regex.test(inputValue) || inputValue === "") {
        if (values.payablePendingAmount >= inputValue) {
          setPaymentValues({ ...paymentValues, [name]: inputValue });
        } else {
          showResMsg("Payment Amount can't be more than Payable Pending Amount", 1000, false)
        }
      }
    }
    else if (name === 'paymentType') {
      if (inputValue === "Full Payment") {
        setPaymentValues({ ...paymentValues, [name]: inputValue, paymentAmount: values.payablePendingAmount });
      } else {
        setPaymentValues({ ...paymentValues, [name]: inputValue, paymentAmount: "" });
      }
    }
    else if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setPaymentValues({ ...paymentValues, [name]: inputValue });
    } else if (event.target.validity === undefined) {
      setPaymentValues({ ...paymentValues, [name]: inputValue });
    }
  }
  const paymentColumns = [
    {
      name: "Payment Date",
      selector: (row) => row.paymentDate,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Transaction ID",
      selector: (row) => row.paymentTransactionID,
      style: { paddingLeft: "10px" },
    },
    {
      name: "Payment Type",
      selector: (row) => row.paymentType,
      style: { paddingLeft: "10px" },
    },
    {
      name: `Paid Amount (${values.currencyValue})`,
      selector: (row) => row.paymentAmount,
      center: "true",
      style: { paddingLeft: "10px" },
    },
    {
      name: `Pending Amount (${values.currencyValue})`,
      selector: (row) => row.pendingAmount,
      center: "true",
      style: { paddingLeft: "10px", },
    },

  ];
  const clearMandateErr = () => {
    setPaymentAmountErr(false);
    setPaymentModeErr(false);
    setPaymentTransactionIDErr(false);
  }
  const handleSubmitPaymentDetails = async () => {
    try {
      clearMandateErr();

      let mandateFlag = false;
      if (paymentValues.paymentType !== "Full Payment") {
        mandateFlag = validateField(paymentValues.paymentAmount, setPaymentAmountErr) || mandateFlag;
        if (parseFloat(paymentValues.paymentAmount) <= 0.00) {
          setPaymentAmountErr(true);
          mandateFlag = true;
        }
      } else if (paymentValues.paymentType === "Retention Payment") {
        if (paymentValues.retentionInvoiceList.length === 0) {
          Swal.fire({
            title: "Choose Retention Invoice!",
            text: `Select atleast one Retention Invoice to proceed!`,
            icon: "question"
          });
          mandateFlag = true;
        }


      } else {
        paymentValues.paymentAmount = values.payablePendingAmount;
      }
      mandateFlag = validateField(paymentValues.paymentMode, setPaymentModeErr) || mandateFlag;
      mandateFlag = validateField(paymentValues.paymentTransactionID, setPaymentTransactionIDErr) || mandateFlag;
      if (mandateFlag) return;
      paymentValues.invoiceID = InvoiceID;
      paymentValues.signatureKey = appConstants.SIGNATURE_KEY;
      ShowSwalWithButtons(
        'Are you sure?', `Would you like to submit the ${paymentValues.paymentType + " " + values.currencyValue + parseFloat(paymentValues.paymentAmount).toFixed(2)} of Invoice ${values.invoiceNumber}?`, 'warning', darkMode,
        () => {
          setLoading(true);
          axios.post(appConstants.baseURL + 'invoice/submitInvoicePaymentDetailsByCustomer', paymentValues).then(res => {

            if (res.data.Result_Status) {
              setPaymentValues({
                ...paymentValues,
                paymentAmount: 0.00,
                paymentTransactionID: "",
                paymentMode: "",
              })
              showResMsg(res.data.Result_Message, 2000, true)
              if (res.data.Result_Output.invoiceStatus === "Paid") {
                setConfirmationMessage(`for paying the ${values.invoiceNumber} Invoice Amount.`);
                setShowConfirmationSection(true);
                setShowInvoiceSection(false);
              } else {
                setShowConfirmationSection(false);
                setShowInvoiceSection(true);
                FetchUnpaidInvoiceForCustomer();
              }


            } else {
              swal("Warning", res.data.Result_Message, "warning");
              setShowConfirmationSection(false);
              setShowInvoiceSection(true);
              setShowClosingSection(false);
            }
            setLoading(false);
          });
        }
      );
    } catch (error) {
      setLoading(false);
      console.error('Error in handleSubmitPaymentDetails:', error.message);
    }
  };
  return (
    <QuotationLayout >
      <Grid sx={{ mt: 2, mb: 2 }}>

        {showInvoiceSection ?
          <>
            <Card color="primary" sx={{ pb: 2, boxShadow: "3px 3px 3px 3px #cdcdcd" }}>
              <PageTitle screenName="Payment for Invoice" />
              <Box component="section">
                <Box>
                  <Grid container px={3} mt={2} spacing={2} >
                    <Grid item lg={2} xs={4}>
                      <Box>
                        <Typography style={{ fontSize: "0.75rem", fontWeight: "600" }}>Invoice No.</Typography>
                        <Typography style={{ fontSize: "0.75rem", color: '#1ed6c9', fontWeight: "600" }}>{values.invoiceNumber}</Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={1.5} xs={4}>
                      <Box  >
                        <Typography style={{ fontSize: "0.75rem", fontWeight: "600", }}>Invoice Type</Typography>
                        <Typography style={{ fontSize: "0.75rem" }}>{values.invoiceType}</Typography>
                      </Box>
                    </Grid>


                    {values.invoiceType === "Through Quotation" &&
                      <Grid item lg={1.5} xs={4}>
                        <Box  >
                          <Typography style={{ fontSize: "0.75rem", fontWeight: "600", }}>Quotation No.</Typography>
                          <Typography style={{ fontSize: "0.75rem", }}>{values.quotationNumber}</Typography>
                        </Box>
                      </Grid>
                    }

                    <Grid item lg={1.5} xs={4}>
                      <Box  >
                        <Typography style={{ fontSize: "0.75rem", fontWeight: "600" }}>Issue Date</Typography>
                        <Typography style={{ fontSize: "0.75rem", }}>{values.invoiceDate}</Typography>
                      </Box>
                    </Grid>



                    <Grid item lg={1.5} xs={4}>
                      <Box  >
                        <Typography style={{ fontSize: "0.75rem", fontWeight: "600" }}>Due Date</Typography>
                        <Typography style={{ fontSize: "0.75rem", }}>{values.dueDate}</Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={1.5} xs={4}>
                      <Box  >
                        <Typography sx={{ ml: 0.7 }} style={{ fontSize: "0.75rem", fontWeight: "600", textAlign: "start" }}>Status</Typography>
                        <Typography sx={{ ml: 0.7 }} style={{ fontSize: "0.75rem", color: "green", fontWeight: "600" }}>{values.invoiceStatus}</Typography>
                      </Box>
                    </Grid>

                    <Grid item lg={1.5} xs={4}>
                      <Box  >
                        <Typography style={{ fontSize: "0.75rem", fontWeight: "600" }}>Currency</Typography>
                        <Typography style={{ fontSize: "0.75rem" }}>{values.currencyValue}</Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box >


              <Box display="flex" justifyContent="end" mt={2}>
                <Typography px={2.5} style={{ fontSize: "0.75rem", textAlign: "center" }}>Amounts are tax {values.gstType}</Typography>
              </Box>
              <CardContent>
                <DataTable
                  columns={columns}
                  data={itemRowValues}
                  customStyles={customStyles}

                />
              </CardContent>


              <Box mt={1.5} display="flex" justifyContent="flex-end" >
                <Box>
                  <Box display="flex" justifyContent="space-between" mt={1}>
                    <MDTypography style={{ fontSize: "14px", fontWeight: "400" }}>Total Amount </MDTypography>
                    <Box px={4} sx={{ ml: { xs: 2, sm: 34, md: 15 } }} >
                      <MDTypography style={{ fontSize: "14px" }} >{values.currencyValue} {(parseFloat(values.totalAmount)).toFixed(2)}</MDTypography>
                    </Box>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mt={1}>
                    <MDTypography style={{ fontSize: "14px", fontWeight: "400" }}>Total Discount </MDTypography>
                    <Box px={4}   >
                      <MDTypography style={{ fontSize: "14px" }}>{values.currencyValue} {(parseFloat(values.totalDiscountAmount)).toFixed(2)}</MDTypography>
                    </Box>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mt={1}>
                    <MDTypography style={{ fontSize: "14px", fontWeight: "400", }} >Total GST </MDTypography>
                    <Box px={4} >
                      <MDTypography style={{ fontSize: "14px" }} > {values.currencyValue} {(parseFloat(values.totalGSTAmount)).toFixed(2)}</MDTypography>
                    </Box>
                  </Box>
                  {/* <Box px={2}> */}
                  <hr style={{ marginRight: "35px" }} />
                  {/* </Box> */}

                  <Box display="flex" justifyContent="space-between" mt={1}>
                    <MDTypography style={{ fontSize: "14px", fontWeight: "600" }} >Grand Total </MDTypography>
                    <Box px={4} sx={{ ml: 2 }}>
                      <MDTypography style={{ fontSize: "14px", fontWeight: "600" }} >({values.currencyValue}) {(parseFloat(values.finalAmount)).toFixed(2)}</MDTypography>
                    </Box>
                  </Box>
                </Box>
              </Box>


              {invoiceDocuments.length > 0 && <>
                <Grid item xs={12} px={2} mt={2.5} md={4} lg={12}>
                  <Button onClick={() => setStatus(!status)}>
                    <MDTypography variant="h6" sx={{ border: "1px solid #000000", borderRadius: "5px", display: 'flex', alignItems: 'center', padding: "2px 10px", }}>
                      <h6 style={{ marginTop: "2px", fontSize: "12px" }}>Attached Documents</h6>
                      {status ? <ArrowDropDown className="arrowdropdown" style={{ marginLeft: "5px", }} /> : <ArrowDropUpIcon className="arrowdropdown" style={{ marginLeft: "5px", }} />}
                    </MDTypography>
                  </Button>
                </Grid>
                {status && <CardContent>
                  <DataTable
                    columns={documentColumns}
                    data={invoiceDocuments}
                    customStyles={customStyles}
                  />
                </CardContent>}
              </>}
            </Card>
            <Card color="success" sx={{ mt: 2 }}>
              <Grid item px={2} pt={1} xs={12} md={4} lg={12} mt={2} >
                <p style={{ fontSize: "14px", fontWeight: "bold", color: "#008000" }} >Invoice Bill Payment</p>
              </Grid>
              {(values.scheduleRetention && retentionItemValues.length > 0) &&
                <CardContent >
                  < DataTable
                    columns={columnRetention}
                    data={retentionItemValues}
                    customStyles={customStyles}
                    selectableRows
                    onSelectedRowsChange={handleRowSelected}
                    selectableRowDisabled={rowDisabledCriteria}
                  />
                </CardContent>
              }
              <Grid container px={2} mt={2} spacing={2} mb={2}>
                <Grid item lg={2} xs={6}>
                  <TextField
                    type="text"
                    label={`Pending Invoice Amount (${values.currencyValue})`}
                    variant="outlined"
                    InputProps={{ padding: "9.2px" }}
                    placeholder={`Invoice Amount (${values.currencyValue})`}
                    fullWidth
                    disabled
                    value={`${parseFloat(values.payablePendingAmount).toFixed(2)}`}
                  />
                </Grid>
                <Grid item lg={2} xs={6}>
                  <TextField
                    type="text"
                    label="Payment Date"
                    // style={{ height: "35.25px", }}
                    variant="outlined"
                    fullWidth
                    InputProps={{ padding: "9.2px" }}
                    InputLabelProps={{ shrink: true }}
                    value={format(new Date(paymentValues.paymentDate), 'MMM dd, yyyy')}
                    disabled
                  />
                </Grid>
                <Grid item lg={2} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Payment Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ height: "42px" }}
                      label="Payment Type"
                      autoFocus
                      value={paymentValues.paymentType}
                      onChange={handleChange('paymentType')}
                    >
                      {values.scheduleRetention && retentionItemValues.length > 0 && <MenuItem value="Retention Payment">Retention Payment</MenuItem>}
                      {!values.scheduleRetention && <MenuItem value="Partial Payment">Partial Payment</MenuItem>}
                      <MenuItem value="Full Payment">Full Payment</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={2} xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Payment Mode</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ height: "42px" }}
                      label="Payment Mode"
                      autoFocus
                      InputLabelProps={{ shrink: true }}

                      value={paymentValues.paymentMode}
                      onChange={handleChange('paymentMode')}
                    >
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="Paypal">Paypal</MenuItem>
                      <MenuItem value="Card">Card</MenuItem>
                      <MenuItem value="Cheque">Cheque</MenuItem>
                      <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                      <MenuItem value="Wire Transfer">Wire Transfer</MenuItem>
                    </Select>
                  </FormControl>
                  {paymentModeErr ? <p style={errMsg}>Payment Mode can't be blank.</p> : ""}

                </Grid>
                <Grid item lg={2} xs={6}>
                  <TextField
                    type="text"
                    label="Transaction ID"
                    variant="outlined"
                    InputProps={{ padding: "9.2px" }}
                    placeholder="Transaction ID"
                    fullWidth
                    value={paymentValues.paymentTransactionID}
                    onChange={handleChange('paymentTransactionID')}

                  />
                  {paymentTransactionIDErr ? <p style={errMsg}>Transaction ID can't be blank.</p> : ""}
                </Grid>

                <Grid item lg={2} xs={6}>
                  {paymentValues.paymentType === "Full Payment" ?
                    <TextField
                      type="text"
                      label={`Payment Amount (${values.currencyValue})`}
                      InputProps={{ padding: "9.2px" }}
                      variant="outlined"
                      placeholder={`Payment Amount (${values.currencyValue})`}
                      fullWidth
                      disabled
                      value={`${parseFloat(values.payablePendingAmount).toFixed(2)}`}
                    />
                    :
                    <TextField
                      type="text"
                      label={`Payment Amount (${values.currencyValue})`}
                      InputProps={{ padding: "9.2px" }}
                      variant="outlined"
                      fullWidth
                      disabled={values.scheduleRetention}
                      onChange={handleChange('paymentAmount')}
                      value={`${paymentValues.paymentAmount}`}
                    />}
                  {paymentAmountErr ? <p style={errMsg}>Payment Amount can't be blank or zero.</p> : ""}
                </Grid>
              </Grid>

              <Grid
                container
                mt={2}
                pb={3}
                spacing={2}
                alignItems="center"
                justifyContent="center"
                display="flex"
              >
                <Grid item container xs={12} md={4} lg={1.8} justifyContent="center">

                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    // fullWidth
                    style={{ height: "40px", width: "165px" }}
                    onClick={() => { setShowInvoiceSection(false); setShowClosingSection(true) }}
                  >
                    Close
                  </MDButton>

                </Grid>
                <Grid item container xs={12} md={4} lg={1.8} justifyContent="center">
                  <MDButton
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    style={{ height: "40px", width: "165px" }}
                    // fullWidth
                    onClick={handleSubmitPaymentDetails}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </Grid>
              {paymentHistory?.length > 0 && <CardContent sx={{ mb: 2 }}>
                <DataTable
                  columns={paymentColumns}
                  data={paymentHistory}
                  customStyles={customStyles}
                />
              </CardContent>}
            </Card>
          </>
          :
          <>
            <Grid style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Card color="success" sx={{ display: "grid", placeItems: "center", height: { xs: '70vh', sm: '60vh', md: '50vh' }, boxShadow: "5px 5px 5px 5px grey", width: { xs: "100%", sm: "60%", md: "50%" }, }}>

                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", }} >
                  {showConfirmationSection ? (<img src={checkCircleIcon} alt="success" />) : (<iframe src="https://giphy.com/embed/l0JM83bF1jbRsTnNu" style={{ height: "120px" }} frameBorder="0" class="giphy-embed" allowFullScreen />)}
                </Grid>
                {/* Logo Name */}
                <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", }} >
                  <Typography sx={{ fontSize: "2rem", fontWeight: "bold", marginTop: "-20px" }} >Invoice & Recover</Typography>
                </Grid>


                {showClosingSection &&
                  <>
                    <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", }} >
                      <Typography sx={{ fontSize: "1.5rem", fontWeight: "bold", fontStyle: "oblique", marginTop: "-45px" }} >Thank you for visit</Typography>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "center", alignItems: "center", }} >
                      <Button className="backbtn" onClick={() => { setShowInvoiceSection(true); setShowClosingSection(false) }}>
                        <ArrowBack />
                        Back to site
                      </Button>
                    </Grid>
                  </>
                }

                {showConfirmationSection &&
                  <>
                    <Grid sx={{ display: "flex", justifyContent: "center", fontSize: "10rem", alignItems: "center", }} >
                      <Typography sx={{ display: "flex", justifyContent: "center", fontSize: "1.8rem", fontWeight: "bold", alignItems: "center", fontFamily: "poppins" }} >
                        Thank You</Typography>
                    </Grid>

                    <Grid sx={{ display: "flex", justifyContent: "center", fontSize: "10rem", alignItems: "center", }} >
                      <Typography sx={{ display: "flex", justifyContent: "center", fontSize: "1rem", alignItems: "center", fontWeight: "Bold" }} >
                        {confirmationMesssage}
                      </Typography>
                    </Grid>
                  </>
                }
              </Card>
            </Grid>
          </>
        }
      </Grid>

      <Modal
        open={viewDocumentInModal}
        onClose={() => setViewDocumentInModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
        }}
      >
        <Card sx={pdfStyle}>

          {/* <Card sx={pdfStyle}> */}
          <Box>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              File Viewer
            </Typography>
            <iframe title="File Viewer" src={getDocumentFileURL} width="100%" height="650" className="ressst" allowFullScreen={true} ></iframe>

            <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
              <MDButton color="warning" className="modalButton" onClick={() => { setViewDocumentInModal(false) }}>
                Close
              </MDButton>
            </Grid>
          </Box>
        </Card>
      </Modal>
      <LoadingModal loading={loading} />

    </QuotationLayout>
  )
}

export default CustomerViewInvoice;
